export default __webpack_public_path__ + "static/media/expl-nn_03_DE.a6e06c29.png";